<template>
  <b-card style="padding:40px;">
    <h5><b>LIST OF PURCHASE ORDER</b></h5>
    <hr />
    <TablePurchaseOrderIndex
      :fields="fields.fields"
      :type="`main`"
      :filter="this.filter"
      :page="this.page"
      :name="this.name"
      :date="this.date"
      />
  </b-card>
</template>

<script>
import TablePurchaseOrderIndex from "@/table/admin/purchaseOrder/TablePurchaseOrderIndex";

export default {
  data() {
    return {
      items: [],
      fields: {
        fields: [
          {
            label: "No",
            key: "index",
            sortable: false
          },
          {
            label: "Company Name",
            key: "companyName",
            sortable: true
          },
          {
            label: "Name",
            key: "name",
            sortable: true
          },
          {
            label: "Date",
            key: "date",
            sortable: true
          },
          {
            label: "Action",
            key: "action",
            sortable: false
          }
        ]
      },
      filter: "",
      page: "",
      name: "",
      date: ""
    };
  },
  created() {
    if (this.$route.query.filter !== undefined) {
      this.filter = this.$route.query.filter;
      this.page = this.$route.query.page;
      this.name = this.$route.query.name;
      this.date = this.$route.query.date;
    }
  },
  methods: {},
  components: {
    TablePurchaseOrderIndex
  }
};
</script>
<style lang="css" scoped></style>
